import React from 'react';
import HeroSectionHealthcare from '../components/HeroSectionHealthcare';
import LogoSection from '../components/LogoSection';
import StatsSectionHealthcare from '../components/StatsSectionHealthcare';
import TaleOfTwoOwnersSection from '../components/TaleOfTwoOwnersSection';
import TeamSection from '../components/TeamSection';
import TimelineSection from '../components/TimelineSection';
import FAQSection from '../components/FAQSection';
const HealthcareClinicsPage = () => {
  return <main className="flex-grow" data-id="element-410">
      <HeroSectionHealthcare data-id="element-411" />
      <LogoSection data-id="element-412" />
      <StatsSectionHealthcare data-id="element-413" />
      <TaleOfTwoOwnersSection data-id="element-414" />
      <TeamSection data-id="element-415" />
      <TimelineSection data-id="element-416" />
      <FAQSection data-id="element-417" />
    </main>;
};
export default HealthcareClinicsPage;